import { useInfiniteMailBox } from '@ukpostbox/client-data';
import { useMailbox } from '../../Providers/NewMailboxProvider';
import { MailboxRoot } from './MailboxRoot';

function Mailbox() {
	const { parsedFilters } = useMailbox();

	const {
		status,
		error,
		data,
		dataUpdatedAt,
		isFetchingNextPage,
		fetchNextPage,
		hasNextPage,
		isStale,
		isRefetching,
	} = useInfiniteMailBox(parsedFilters);

	return (
		<MailboxRoot
			status={status}
			error={error}
			isFetchingNextPage={isFetchingNextPage}
			fetchNextPage={fetchNextPage}
			dataUpdatedAt={dataUpdatedAt}
			data={data}
			hasNextPage={hasNextPage}
			isRefetching={isRefetching}
			isStale={isStale}
		/>
	);
}

export { Mailbox };
